<template>
    <el-card class="bank-warn" v-if="messageState">
        <div slot="header">
            <div class="bank-warn-title">供应商消息提示</div>
            <i
                class="bank-warn-close el-icon-close"
                @click="onColse"
            ></i>
        </div>
        <div class="bank-warn-content">
            <div class="notification-content-top">您好！</div>
            <div class="notification-content-middle">
                供应商编码{{ supplierCode }}，银行账户{{ bankAccountListStr }},检测到您的收款账户开户行信息已失效，请联系安得调度人员及时更新，否则影响后续付款！
            </div>
        </div>
        <div class="bank-warn-footer">
            <!-- <el-button @click="goUpdate">前往更新</el-button> -->
            <el-button :loading="loading" @click="onRemind">已知悉，无需再次提醒</el-button>
        </div>
    </el-card>
</template>

<script>
import { supplierFinanceWarning, noTips } from "../api/notificationWarn.js";

export default {
    data() {
        return {
            messageState: false,
            id: '',
            supplierCode: '',
            bankAccountList: [],
            loading: false,
        };
    },
    computed: {
        bankAccountListStr() {
            return this.bankAccountList.join(',')
        }
    },
    mounted() {
        setTimeout(() => {
            this.init();
        }, 3000);
    },
    methods: {
        init() {
            const value = sessionStorage.getItem('bankMessageState');
            if (!value) {
                this.getData();
            }
        },
        getData() {
            if (!this.$store.state.supplier.supplierCode) {
                return false;
            }
            supplierFinanceWarning().then(res => {
                if (res && +res.code === 0 && res.data) {
                    this.id = res.data.id
                    this.supplierCode = res.data.supplierCode
                    this.bankAccountList = res.data.bankAccountList
                    this.messageState = true
                }
            });
        },
        onColse() {
            sessionStorage.setItem('bankMessageState', true)
            this.messageState = false
        },
        // goUpdate() {
        //     this.onColse()
        //     this.$router.push({
        //         path: '/lsrm/basicInfo',
        //         query: { tabFinance: 1 },
        //     })

        // },
        onRemind() {
            const params = { id: this.id };
            this.loading = true
            noTips(params).then(res => {
                if (res && +res.code === 0) {
                    this.onColse();
                }
            }).finally(() => { this.loading = false });
        },
    }
};
</script>

<style scoped lang="less">
.bank-warn {
    position: absolute;
    bottom: 5px;
    right: 80px;
    width: 280px;
    // height: 208px;
    // opacity: 0;
    transition: all 0.8s ease;
    z-index: 9999;

    /deep/.el-card__header {
        padding: 10px 18px;
    }

    &-title {
        // height: 30px;
        // line-height: 30px;
        text-align: center;
        // border: 1px solid blue;
    }

    &-close {
        position: absolute;
        right: 5px;
        top: 10px;
        font-size: 20px;
        cursor: pointer;

        &:hover {
            color: #00bcbf;
        }
    }

    &-content {
        font-size: 12px;

        // .notification-content-top {
        //     display: flex;
        //     height: 26px;
        //     align-items: center;
        //     justify-content: space-between;
        // }

        .notification-content-middle {
            overflow: auto;
            margin: 6px 0;
            word-break: break-all;
            text-indent: 24px;
        }
    }

    &-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin: 5px 0;
        height: 30px;
        // border: 1px solid blue;
        // line-height: 30px;
        // text-align: center;
    }
}
</style>
